import React, { useContext, useMemo, useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { GlobalContext } from '../../helper/context'

function SaveState () {
  const contextValue = useContext(GlobalContext)

  return useMemo(() => (<span>{
    contextValue.saveState === 'saved' ? 'Saved' : (
      contextValue.saveState === 'saving' ? 'Saving' : <span css={css`color: #A82A2A;`}>Failed</span>
    )
  }</span>
  ), [contextValue.saveState])
}

export default SaveState
